import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ColorsContext from 'app/react/components/colors/ColorsContext'

export default function ColorVariant (props) {

  const { buttonTexts } = useContext(ColorsContext)
  const [isCopied, setIsCopied] = useState(false)

  const handleOnClick = () => {
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 2000)
  }

  const style = {
    background: props.bgColor,
    opacity: props.opacity
  }

  return (
    <div className="dm-colors__color-variant dm-hover-content dm-hover-content--no-overlay">
      <div className="dm-colors__color-variant-inner" style={style}/>
      <div className={classNames('dm-colors__color-variant-name', {
        'dm-colors__color-variant-name--color-black': props.textIsDark
      })}>
        <div>{props.title}</div>
        <span>({props.currColor})</span>
      </div>
      <div className="dm-hover-content__content">
        <CopyToClipboard text={props.currColor}>
          <div
            className={classNames('dm-button', {
              'dm-button--copy-outline': !props.textIsDark,
              'dm-button--copy-outline-dark': props.textIsDark,
              'dm-button--show-checkmark': isCopied,
            })}
            onClick={handleOnClick}
          >
            <span className="dm-button__checkmark"></span>
            {isCopied ? buttonTexts.isCopied : buttonTexts.copy}
          </div>
        </CopyToClipboard>
      </div>
    </div>
  )
}